import * as contentDetailsTokens from "./contentDetailsTokens";
import * as fontTokens from "./fontTokens";
import * as framerateParametersTokens from "./framerateParametersToken";
import { INPUT_FILE_TOKEN } from "./inputFileToken";
import { OUTPUT_FILE_TOKEN } from "./outputFileToken";
import * as whitespaceTokens from "./whitespaceTokens";

export { OUTPUT_FILE_TOKEN } from "./outputFileToken";

export const requiredTokens = {
    INPUT_FILE_TOKEN,
    OUTPUT_FILE_TOKEN
};

export const optionalTokens = {
    ...contentDetailsTokens,
    ...fontTokens,
    ...framerateParametersTokens,
    ...whitespaceTokens
};
